import { Project } from './project';
import { Account } from './account';


export interface IObject {
  readonly id: number;
  class?: string;
  state?: string;
  subclass?: string;
  className?: string;
  name?: string;
  imageUrl?: string;
  content?: string;
  projectId?: number;
  project?: Project;
  modifierAccount?: Account;
  identifier?: string;
  primaryKeyword?: string;
  secondaryKeyword?: string;
  modifyDate?: string;
  createDate?: string;
  number?: any;
  meta?: any;
  objects?: IObject[];
  relatedObjectHighlight?: number;
  inheritedRelatedObject?: any;
  parentObject?: any;
}
